import React, { useEffect, useState } from "react";
import { DefaultButton } from "../../../Buttons";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "../../../../data/linearCalendar/actions";
import { RESERVE_BID_SCOPE } from "../../../../data/constants";
import { useSessionStorageListener } from "../../helpers";
import { getLastBidScopeUsedString } from "../../../../scenes/BidSession/helpers";
import { useLanguage } from "../../../../context/LanguageContext";

const AddButton = withStyles({
  root: {
    color: "#009688 !important",
    backgroundColor: "#d2e6e4 !important",
    fontWeight: "bold !important",
    fontSize: "12px !important",
    "&:disabled": {
      opacity: "0.5",
      cursor: "none",
    },
  },
})(DefaultButton);

const AddToCalendar = (props) => {
  const { labels } = useLanguage();
  const openTimeSearchLabels = labels.openTimeSearchLabels || {};
  const [isDisabled, setIsDisabled] = useState(
    getLastBidScopeUsedString() === RESERVE_BID_SCOPE
  );

  // Use the helper to listen for sessionStorage changes
  useSessionStorageListener(() => {
    const currentScope = getLastBidScopeUsedString();
    setIsDisabled(currentScope === RESERVE_BID_SCOPE);
  });

  const handleRequest = () => {
    const { updateCalendar, activity, setFromAddButton } = props;
    setFromAddButton(true);

    // MUST CREATE a copy before we manipulate the array
    const copiedActivities = { ...props.activities.activities };
    const types = props.activities.types;
    const entriesNew = copiedActivities && copiedActivities.entries;

    const activityId = activity.activityId;
    const credit = activity.credit;
    const activityType = activity.type;
    const endDateRaw = activity.endDate;
    const startDateRaw = activity.startDate;
    const name = activity.name;
    const nbSeniorOutbids = activity.nbSeniorOutbids;

    if (
      copiedActivities.entries.filter(
        (e) => e.activityId === activity.activityId
      ).length === 0
    ) {
      entriesNew.push({
        active: true,
        activityId,
        blockTime: 0,
        credit,
        endDate: endDateRaw,
        isVacationEditable: false,
        lineNumber: null,
        name,
        originalEndDate: endDateRaw,
        originalStartDate: startDateRaw,
        addedByUser: true,
        restTimeAfter: null,
        source: 2,
        startDate: startDateRaw,
        status: null,
        type: activityType,
        vacationSlideEndDate: null,
        vacationSlideStartDate: null,
        validatedVacationSlideEndDate: null,
        validatedVacationSlideStartDate: null,
        nbSeniorOutbids,
      });
      updateCalendar({
        activities: {
          entries: entriesNew,
          end: copiedActivities.entries.length - 1,
          totalEntries: copiedActivities.entries.length,
        },
        types,
      });
    }
  };

  return (
    <div className="add-button">
      <AddButton disabled={isDisabled} onClick={() => handleRequest()}>
        {openTimeSearchLabels.details.ADD_TO_CALENDAR}
      </AddButton>
    </div>
  );
};

const mapStateToProps = (state) => ({ ...state.linearCalendar });

const mapDispatchToProps = (dispatch) => ({
  updateCalendar: (activities) =>
    dispatch(actions.default.updateCalendar(activities)),
});

AddToCalendar.propTypes = {
  activities: PropTypes.object.isRequired,
  activity: PropTypes.object.isRequired,
  updateCalendar: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddToCalendar);
